import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/home'
    },
    {
        path: "/login",
        name: "login",
        meta: {
            title: '登录'
        },
        component: () => import("../views/login.vue")
    },
    {
        path: '/area',
        name: 'area',
        component: () => import('../views/area.vue')
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/index.vue')
    },
    {
        path: '/left',
        name: 'left',
        component: () => import('../views/home/left.vue')
    },
    {
        path: '/center',
        name: 'center',
        component: () => import('../views/home/center.vue')
    },
    {
        path: '/right',
        name: 'right',
        component: () => import('../views/home/right.vue')
    }


]
const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach((to, from, next) => {
    // document.title = `${to.meta.title} | uict_agedcaring`;
    document.title = "融大屏";
    console.log(location.href);
    let url = location.href
    let hasQueryString = url.includes("=");
    if (hasQueryString) {
        let queryString = url.substring(url.indexOf("=") + 1);
        localStorage.setItem('token', queryString)
    }
    const token = localStorage.getItem('token');
    if (!token && to.path !== '/login') {
        next('/login');
    } else {
        next();
    }

});


export default router
